import { Box } from 'grommet'
import styled, { css } from 'styled-components'

import Hexagon from '@public/images/svg/gray-hexagon.svg'
import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  flex-direction: column;
  position: relative;
  width: 100%;

  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.xl}px;
      margin-top: ${theme.newSpaces.xl2}px;
    `}
  `}
`

export const Content = styled(Box)`
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;

  ${({ theme }) => theme.below.tabletL`
    flex-direction: column;
    justify-content: center;
  `}
`

export const Members = styled(Box)`
  flex-direction: row;
  flex-wrap: wrap;
  position: relative;
  width: 400px;

  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl6}px;
    ${theme.below.laptop`
      align-items: center;
      margin: ${theme.newSpaces.xl}px auto ${theme.newSpaces.sm}px;
      margin-top: 0;
    `}

    ${theme.below.tabletL`
      width: 100%;
      margin-top: 0;
    `}

    ${theme.below.mobileXL`
      display: grid;
      grid-template-columns: 1fr 1fr;
      row-gap: 20px;
      column-gap: 15px;
      position: relative;
      width: 400px;
      margin-top: 0;
    `}
  `}
`

export const ImageWrapper = styled(Box)`
  ${({ theme }) => css`
    img {
      height: 100%;
      width: 100%;
    }

    ${theme.above.laptopL`
      max-width: 670px;
    `}

    ${theme.below.laptopL`
      max-width: 645px;
    `}

    ${theme.below.laptop`
      max-width: 100%;
    `}
  `}
`
